var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAmazonCreditBalance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.63561 5.3172L9.21784 13.7614C9.21784 13.7614 9.31392 16.3448 6.63561 16.3448C3.89286 16.3448 4.00871 13.7079 4.00871 13.7079L6.63561 5.3172Z",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2673 5.3172L20.8495 13.7614C20.8495 13.7614 20.9456 16.3448 18.2673 16.3448C15.5245 16.3448 15.6404 13.7079 15.6404 13.7079L18.2673 5.3172Z",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3575 19.2827L15.0185 20.2679C15.0352 20.2777 15.0491 20.2918 15.0587 20.3087C15.0684 20.3256 15.0734 20.3447 15.0734 20.3642V21.2169C15.0734 21.235 15.0662 21.2523 15.0535 21.265C15.0407 21.2778 15.0235 21.285 15.0054 21.2851H11.0679C11.0498 21.285 11.0326 21.2778 11.0198 21.265C11.0071 21.2523 11 21.235 11 21.2169V20.3467C11 20.3274 11.005 20.3084 11.0145 20.2915C11.0241 20.2747 11.0378 20.2606 11.0544 20.2507L12.6754 19.282L13.3575 19.2827Z",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6744 3.84601H6.90979",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4.83789V19.2842",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9834 13.7187H15.6391",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23309 13.7187H4",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8738 4.7474C13.3563 4.7474 13.7475 4.35623 13.7475 3.8737C13.7475 3.39117 13.3563 3 12.8738 3C12.3912 3 12 3.39117 12 3.8737C12 4.35623 12.3912 4.7474 12.8738 4.7474Z",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62272 4.34173C6.88366 4.34173 7.09519 4.13021 7.09519 3.86929C7.09519 3.60837 6.88366 3.39685 6.62272 3.39685C6.36177 3.39685 6.15024 3.60837 6.15024 3.86929C6.15024 4.13021 6.36177 4.34173 6.62272 4.34173Z",
    fill: "white",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2618 4.32776C18.5227 4.32776 18.7343 4.11624 18.7343 3.85531C18.7343 3.59439 18.5227 3.38287 18.2618 3.38287C18.0009 3.38287 17.7893 3.59439 17.7893 3.85531C17.7893 4.11624 18.0009 4.32776 18.2618 4.32776Z",
    fill: "white",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAmazonCreditBalance);
export default __webpack_public_path__ + "static/media/ic_amazon_credit_balance.73aa05a2977f644ea7d9bd490c85bd66.svg";
export { ForwardRef as ReactComponent };